import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function HomeIntro() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-100 px-6 py-10 md:px-10 md:py-12">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
        <div>
          <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {siteInfo.brand}
          </h1>
          <p className="mt-2 font-heading text-sm font-medium text-primary-600">{siteInfo.slogan}</p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">{siteInfo.intro}</p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">{siteInfo.introDetail}</p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            了解更多
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {siteInfo.stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <p className="font-heading text-2xl font-bold text-primary-600">{stat.value}</p>
              <p className="mt-1 text-sm text-foreground-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}